import GeneratedFromAddressStore from "./generated/GeneratedFromAddressStore"

class FromAddressStore extends GeneratedFromAddressStore {

}

export const fromAddressStore = new FromAddressStore()
